import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import {
  AUTH_INTERVAL_TIME,
  IDLE_TIMEOUT,
  ROUTES,
  eventMouse,
} from "./utils/constants";
import PrivateComponent from "./Components/PrivateComponent";
import PublicComponent from "./Components/PublicComponent";
import Signup from "./containers/authentication/Signup";
import Login from "./containers/authentication/Login";
import HowToBegin from "./containers/HowToBegin";
import CTHeader from "./Components/CTHeader";
//import CarbnAssistant from "./Components/Assistant/Carbnassistant";

import Header from "./Components/Header";
import { Amplify } from "aws-amplify";
import { awsExports } from "./aws-exports";
import LandingPage from "./Components/LandingPage";
import CTFooter from "./Components/Footer/Footer";
import ParagraphSelector from "./Components/LandingPage/ParagraphSelector";
import "@fontsource/roboto";
import "./App.css";
import Stepper from "./containers/stages";
import "@fontsource/plus-jakarta-sans";
import Dashboard from "./containers/Dashboard";
import DownloadExe from "./Components/ProductRegistration/DownloadExe";
import Notifications from "./Components/Notification";
import setTrackingCookie from "./utils/TrackingCookie";
import Pricing from "./Components/Pricing";
import LandingPrivateComponent from "./Components/PrivateComponent/LandingPrivateComponent";
import Payment from "./Components/Payment";
import PaymentSuccess from "./Components/Payment/PaymentSuccess";
import PaymentOptions from "./Components/Payment/PaymentOptions";
import PageNotFound from "./Components/PageNotFound";
import ConfirmationPage from "./Components/Comfirmation";
import Logout from "./containers/authentication/Logout";
import $ from "jquery";
import { useDispatch } from "react-redux";
import { Auth } from "aws-amplify";
import { setActiveUser, setLoggedIn, setUserData } from "./redux/users";
import RazorpaySuccess from "./Components/Payment/Razorpay/RazorpaySuccess";
import { setAboutYouStage, setHubspotStage } from "./redux/stages";
import store from "./redux/store";
import FreemiumSuccess from "./Components/Payment/FreemiumSuccess";
import Version from './Components/Version';
import { refreshCognitoSession } from "./utils/common";

window.$ = $;

Amplify.configure({
  Auth: {
    region: awsExports.REGION,
    userPoolId: awsExports.USER_POOL_ID,
    userPoolWebClientId: awsExports.USER_POOL_APP_CLIENT_ID,
  },
});




function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const dispatch = useDispatch();
  let timer;
  
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === " " && e.target.tagName === "BUTTON") {
        e.preventDefault(); // Block space
      } else if (e.key === "Enter" && e.target.tagName === "BUTTON") {
        e.target.click(); // Simulate click only for Enter
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);



  
  // State for ParagraphSelector visibility
  const [showParagraphSelector, setShowParagraphSelector] = useState(false);

  useEffect(() => {
    setTrackingCookie();

    //Scroll To Add Class
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll >= 10) {
        $(".header").addClass("darkHeader");
      } else {
        $(".header").removeClass("darkHeader");
      }
    });
    
  }, []);

  const handleKeyDown = (event) => {
    // Toggle ParagraphSelector on Ctrl+Shift+X
    if ((event.key === 'X' || event.key === 'x')) {
      //alert("iiner");
      event.preventDefault();
      setShowParagraphSelector(!showParagraphSelector);
      console.log('ParagraphSelector toggled:', !showParagraphSelector);
    }
  };

  // Global keyboard shortcut handler for ParagraphSelector
  useEffect(() => {
  
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [showParagraphSelector]);

  useEffect(() => {
    setInterval(() => {

      console.log("=== SESSION REFRESH STARTED ===");

      //Check if anything is downloading then refresh the session in every 9 minutes
      // const state = store?.getState();
      // const progressBar = state?.users?.progress;
      // const dbDirectProgressBar = state?.users?.dbDirectProgress;
      // const ollamaFileProgressBar = state?.users?.ollamaFileProgress;
      // if (
      //   (progressBar > 0 && progressBar <= 100) ||
      //   (dbDirectProgressBar > 0 && dbDirectProgressBar <= 100) ||
      //   (ollamaFileProgressBar > 0 && ollamaFileProgressBar <= 100)
      // ) {
      //   setRefreshSession();
      // }

      console.log("refresh session appjs");
      Auth.currentSession().then((session) => {
          console.log("in the App refresh session");
          const refreshToken = session.getRefreshToken();

          Auth.currentAuthenticatedUser().then((res) => {
              console.log("in the App refresh session inner");
              res.refreshSession(refreshToken, (err, data) => {
                console.log(data.getIdToken().getJwtToken());
                if (err) {
                  console.log("=== SESSION REFRESH ENDED (FAILED) ===");
                  console.log("error in refresh session");
                  if (store?.getState()?.users?.activeUser) {
                    console.log("=== SESSION handleLogout ===");
                    handleLogout();
                  }
                } else {
                  console.log("=== SESSION REFRESH ENDED (SUCCESS) ===");
                  console.log("success in refresh session");
                  Auth.currentUserInfo()
                    .then((resp) => {
                      const userObj = {
                        username: res?.username,
                        attributes: resp?.attributes,
                        token: data.getIdToken().getJwtToken(),
                      };
                      console.log("=== SESSION Auth ===");
                      dispatch(setActiveUser(true));
                      dispatch(setUserData(userObj));
                    })
                    .catch((e) => console.log(e));
                }
              });
            })
            .catch((e) => { console.log(e); console.log("No user in catch above"); }
          );
        })
        .catch((e) => { console.log(e); console.log("No user in catch"); });
    }, AUTH_INTERVAL_TIME);
  }, []);

  // when component mounts, it adds an event listeners to the window
  // each time any of the event is triggered, i.e on mouse move, click, scroll, keypress etc, the timer to logout user after 10 secs of inactivity resets.
  // However, if none of the event is triggered within 10 secs, that is app is inactive, the app automatically logs out.
  useEffect(() => {
    Object.values(eventMouse).forEach((item) => {
      window.addEventListener(item, () => {
        resetTimer();
        handleLogoutTimer();
      });
    });
  }, []);

  // this function sets the timer that logs out the user after 10 secs
  const handleLogoutTimer = () => {
    timer = setTimeout(() => {
      // clears any pending timer.
      resetTimer();
      // Listener clean up. Removes the existing event listener from the window
      Object.values(eventMouse).forEach((item) => {
        window.removeEventListener(item, resetTimer);
      });
      // logs out user
      logoutAction();
    }, IDLE_TIMEOUT); // 10000ms = 10secs. You can change the time.
  };

  // this resets the timer if it exists.
  const resetTimer = () => {
    if (timer) clearTimeout(timer);
  };

  // logs out user by clearing out auth token in localStorage and redirecting url to /signin page.
  const logoutAction = () => {
    const state = store?.getState();
    const progressBar = state?.users?.progress;
    const dbDirectProgressBar = state?.users?.dbDirectProgress;
    const ollamaFileProgressBar = state?.users?.ollamaFileProgress;
    if (
      (progressBar > 0 && progressBar <= 100) ||
      (dbDirectProgressBar > 0 && dbDirectProgressBar <= 100) ||
      (ollamaFileProgressBar > 0 && ollamaFileProgressBar <= 100)
    ) {
      //refresh token if somehouw logoutaction function perform and is in the middle of download
      //setRefreshSession();
    } else {
      console.log("logout action else");
      if (store?.getState()?.users?.activeUser) {
       handleLogout();
      }
    }
  };

  const handleLogout = () => {
    console.log("handle logout Apps js");
    Auth.signOut().then(() => {
      dispatch(setUserData(null));
      dispatch(setActiveUser(false));
      dispatch(setAboutYouStage(null));
      dispatch(setLoggedIn(false));
      dispatch(setHubspotStage(null));
      window.location.href = "/";
    });
  };

  return (
    <>
      <div className="App scrollbar">
        <Router>
          <ScrollToTop />
          <CTHeader />
          <Header />
          <Routes>
            <Route path={ROUTES.LOGOUT} element={<Logout />} />
            <Route element={<LandingPrivateComponent />}>
              <Route path={ROUTES.LANDING_PAGE} element={<LandingPage />} />
            </Route>
            <Route element={<PrivateComponent />}>
              <Route path={ROUTES.DOWNLOAD} element={<DownloadExe />} />
              <Route path={ROUTES.HOW_TO_BEGIN} element={<HowToBegin />} />
              <Route path={ROUTES.APP_STAGE} element={<Stepper />} />
              <Route
                path={ROUTES.CONFIRMATION}
                element={<ConfirmationPage />}
              />
              <Route path={ROUTES.DASHBOARD} element={<Dashboard />} />
              <Route path={ROUTES.NOTIFICATION} element={<Notifications />} />
              <Route path={ROUTES.PAYMENTDETAIL} element={<Payment />} />
              <Route path={ROUTES.PRICING} element={<Pricing />} />
              <Route path={ROUTES.PAYMENTOPTION} element={<PaymentOptions />} />
              <Route
                path={ROUTES.PAYMENTSUCCESS}
                element={<PaymentSuccess />}
              />
              <Route
                path={ROUTES.RAZORPAY_SUCCESS}
                element={<RazorpaySuccess />}
              />
              <Route
                path={ROUTES.FREEMIUM_SUCCESS}
                element={<FreemiumSuccess />}
              />
            </Route>
            <Route element={<PublicComponent />}>
              <Route path={ROUTES.SIGNUP} element={<Signup />} />
              <>
                <Route path={ROUTES.LOGIN} element={<Login />} />
              </>
            </Route>
            <Route path={ROUTES.PAGENOTFOUND} element={<PageNotFound />} />
          </Routes>
          <CTFooter />
        </Router>
        {/* {showParagraphSelector && <ParagraphSelector />} */}
        {/* <CarbnAssistant /> */}
        
        <Version />
        <ToastContainer autoClose={10000} />
      </div>
    </>
  );
}

export default App;
